export default {

    init() {

        const QUIETANZA = "quietanza";
        const MANDATO = "mandato";
        const PREZZO_CONCORDATO = "prezzo_concordato";

        const INPUT_TYPE = "#input-type";
        const INPUT_COMMISSION = "#input-commission";
        const INPUT_VAT = "#input-vat";

        function getViewSelectedType() {
            return $(INPUT_TYPE).val();
        }

        function toggleInputCommission(type) {

            switch (type) {
                case QUIETANZA:
                    $(INPUT_COMMISSION).attr('disabled', true);
                    $(INPUT_VAT).attr('disabled',true);
                    break;
                case MANDATO:
                    $(INPUT_COMMISSION).attr('disabled', false);
                    $(INPUT_VAT).attr('disabled',false);
                    break;
                case PREZZO_CONCORDATO:
                    $(INPUT_COMMISSION).attr('disabled', true);
                    $(INPUT_VAT).attr('disabled',false);
                    break;
            }
        }

        $(INPUT_TYPE).change(function (e) {
            toggleInputCommission(getViewSelectedType());
        });

        toggleInputCommission(getViewSelectedType());

    },

    finalize() {

    },
}
